// A trailing `Z` or `±hh:mm` / `±hhmm` offset.
const EXPLICIT_OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i

/**
 * Parses a Sunny16 `…Utc` date, reading a date-time without an offset as UTC. Sunny16 sends some of
 * these (a promotion's `calculatedEndDateUtc`) without a `Z`, which `new Date()` reads as the
 * browser's local time; a value with a `Z` or an offset is read as it says. Not dayjs: it reads a
 * trimmed .NET fraction like `.5` as 5 milliseconds.
 * Hand-off: `docs/features/2026.09.23-store-behaviour-tests/hand-offs/2026.09.24-001-sunny16-utc-date-kind.md`
 */
export function parseUtcDate(value: Date | string): Date {
  if (value instanceof Date) return value

  const needsZ = value.includes('T') && !EXPLICIT_OFFSET.test(value)
  return new Date(needsZ ? `${value}Z` : value)
}
